import { getPlayerGrade } from '../lib/localStorage'
import { TEACHER_WORDS } from '../teacherWords'

const grade = getPlayerGrade()
const nogradeyet = ['jack']

let GRADEWORDS = nogradeyet

// Fall 2026 rollover — kept identical to constants/wordlist.ts's per-grade
// arrays (same source directory) so a correct daily answer is always a
// valid guess. These two files drifting apart is exactly what caused
// correct answers to get rejected as "not found" after the previous
// rollover — see supabase/migrations/008/009 for the roster-side fix.
const SENIOR = [
  'emerson',
  'william',
  'mitchell',
  'rhodes',
  'daniel',
  'brooke',
  'avery',
  'harris',
  'grant',
  'madeline',
  'cesar',
  'gavin',
  'davis',
  'margot',
  'hotoniel',
  'jack',
  'sam',
  'robby',
  'margaret',
  'gigi',
  'christina',
  'emmy',
  'felipe',
  'florencia',
  'grey',
  'claire',
  'caroline',
  'hailey',
  'ryan',
  'jackson',
  'aj',
  'amara',
  'jon miller',
  'anaya',
  'patrick',
  'juliana',
  'nicholas',
  'finn',
  'connor',
  'andrew',
  'ella',
  'emma',
  'kate',
  'mary',
  'brendan',
  'joselyn',
  'mateo',
  'eliana',
  'graham',
  'nora',
  'will',
  'tuck',
  'amaree',
  'phillip',
  'maxx',
  'betsy',
  'sophie',
  'cole',
  'alexa',
  'sammy',
  'sidney-ann',
  'blair',
  'evelyn grace',
  'gracie',
  'ayokunle',
  'meriwether',
  'paige',
  'ria',
  'amelia',
  'hannah',
  'katlynn',
  'teagan',
  'beatrice',
  'sarah',
  'vance',
  'hunter',
  'brad',
  'tyler',
  'greg',
  'franklin',
  'braiden',
  'annabelle',
  'preston',
  'maddie',
  'tommy',
  'collier',
  'colt',
  'dean',
  'havana',
  'matthew',
  'lily',
  'kade',
  'griffin',
  'hayes',
  'mose',
  'vandy',
  'logan',
  'scarlett',
  'mcvey',
  'george',
  'chloe',
  'luke',
  'layla',
  'ryder',
  'ray',
  'victoria',
  'mayomi',
  'maya',
  'bryce',
  'sienna',
  'grace',
  'bobby',
  'charlie',
  'lilah',
  'sean',
  'kenzo',
  'leah',
  'jules',
  'gabriella',
  'charlotte',
  'sasha',
  'sophia',
  'tanner',
  'marley',
  'eva marie',
  'brent',
  'chase',
  'harley',
  'makayla',
  'grayson',
  'christian',
  'nicole',
]

const JUNIOR = [
  'andrew',
  'madison',
  'brayden',
  'jason',
  'xavier',
  'quinn',
  'madeline',
  'strickland',
  'ingrid',
  'aaniyah',
  'jackson',
  'karissa',
  'zoe',
  'bennett',
  'nicholas',
  'will',
  'cole',
  'bailey',
  'fisher',
  'ronan',
  'bentley',
  'lucas',
  'eden',
  'bree',
  'eva',
  'mackenzie',
  'liam',
  'lane',
  'hudson',
  'thomas',
  'ryan',
  'ellison',
  'garrett',
  'brody',
  'dyer',
  'wyatt',
  'marshall',
  'bryce',
  'grayden',
  'emily',
  'sam',
  'jackie',
  'lila',
  'elizabeth',
  'lydia',
  'davis',
  'teddy',
  'violet',
  'carson',
  'samantha',
  'sky',
  'bella',
  'sloane',
  'martin',
  'landen',
  'cooper',
  'cathryn-rose',
  'mary-grace',
  'cristiano',
  'whitney',
  'addison',
  'charlie',
  'peighton',
  'mary brooks',
  'julia-pun',
  'crosby',
  'gemma',
  'sophia',
  'townsend',
  'belle',
  'alexa',
  'merrick',
  'landon',
  'loriel',
  'connor',
  'bobby',
  'ayden',
  'maia',
  'emme',
  'jonah',
  'caroline',
  'lucy',
  'turner',
  'grant',
  'ava',
  'kaylee',
  'riley',
  'daniel',
  'logan',
  'jude',
  'sarah',
  'maddie',
  'molly',
  'aspen',
  'jack',
  'shane',
  'miller',
  'aubrey',
  'gabby',
  'bryson',
  'allison',
  'makenzie',
  'adair',
  'george',
  'wilkins',
  'treasure',
  'ashley',
  'colt',
  'divya',
]

const SOPHOMORE = [
  'sophie',
  'king',
  'ben',
  'teddy',
  'graham',
  'aaron',
  'morgan',
  'finn',
  'amzie',
  'madeline',
  'cole',
  'krystin',
  'natalie',
  'blakely',
  'jacob',
  'henry',
  'kate',
  'robert',
  'chris',
  'byrdie',
  'mason',
  'fiver',
  'sam',
  'noah',
  'zachary',
  'ken ken',
  'ryan',
  'sawyer',
  'braeden',
  'khloe',
  'hudson',
  'cannon',
  'addie',
  'harrison',
  'gus',
  'banks',
  'hardy',
  'ella',
  'matthew',
  'alessandra',
  'yovela',
  'asher',
  'joey',
  'caroline',
  'nandi',
  'william',
  'ellie',
  'ridge',
  'daniel',
  'temma',
  'ollie',
  'katie',
  'colin',
  'breanna',
  'ellison',
  'parks',
  'joe',
  'nicholas',
  'jake',
  'trey',
  'xavi',
  'lila',
  'samantha',
  'kaleb',
  'penny',
  'melina',
  'bates',
  'miller',
  'jack',
  'ransom',
  'eve',
  'gracie',
  'callan',
  'finley',
  'sanders',
  'hannah',
  'catherine',
  'fernando',
  'aidan',
  'amariah',
  'mark',
  'chelsea',
  'ireland',
  'caden',
  'parker',
  'melanie',
  'auldyn',
  'luke',
  'camille',
  'christian',
  'isabelle',
  'kennedy',
  'alice',
  'truman',
  'ava',
  'haiden',
  'mack',
  'bobby',
  'liam',
  'aria',
  'xavier',
  'adrianna',
  'thomas',
  'rylee',
  'beckett',
  'harry',
  'liza',
  'hattie',
  'bella',
  'sydney',
  'mary drew',
]

const FRESHMAN = [
  'arafen',
  'tyler',
  'harper',
  'mary virginia',
  'abbey',
  'emma',
  'eidan',
  'nate',
  'alaina',
  'camille',
  'talan',
  'hailey',
  'brayden',
  'jd',
  'chandler',
  'ivana',
  'sally',
  'vinny',
  'virran',
  'cam',
  'andrew',
  'jade',
  'gabby',
  'finn',
  'ross',
  'wilder',
  'sydney',
  'mary kathryn',
  'jax',
  'spencer',
  'blake',
  'liam',
  'adonai',
  'abrielle',
  'josiah',
  'isabel',
  'wendy',
  'deuce',
  'abby',
  'caroline',
  'chori',
  'sam',
  'ella',
  'katherine',
  'neilan',
  'megan',
  'ridge',
  'sloane',
  'ben',
  'grayson',
  'tillan',
  'charles',
  'jacaria',
  'jimi',
  'connor',
  'luka',
  'jace',
  'anna',
  'yardley',
  'ilianna',
  'teddy',
  'aleka',
  'whitfield',
  'betsy',
  'dylan',
  'matthew',
  'ruby',
  'ryder',
  'lorelei',
  'wesley',
  'mason',
  'max',
  'idey',
  'william',
  'allison',
  'laney kate',
  'abe',
  'hazel',
  'wells',
  'tommy',
  'henry',
  'constanza',
  'blair',
  'jahmai',
  'aiden',
  'kayla',
  'daniel',
  'daria',
  'nola',
  'sandifer',
  'daniella',
  'lila',
  'sophia',
  'iris',
  'ava',
  'casey',
  'niagrace',
  'lanier',
  'daley',
  'drew',
  'shivani',
  'gabe',
  'mae',
  'cassandra',
  'robert',
  'austin',
  'jackie',
  'jane',
  'klyce',
  'agustin',
  'marlin',
  'tison',
  'holman',
  'harrison',
  'davis',
  'will',
  'avery',
  'fraser',
  'mia',
  'tiger',
  'kimora',
]

// Updated logic mapping to the new high school grades/grad years
if (grade === '0') {
  GRADEWORDS = TEACHER_WORDS
} else if (grade === '') {
  GRADEWORDS = nogradeyet
} else if (grade === '12' || grade === '27') {
  GRADEWORDS = SENIOR
} else if (grade === '11' || grade === '28') {
  GRADEWORDS = JUNIOR
} else if (grade === '10' || grade === '29') {
  GRADEWORDS = SOPHOMORE
} else if (grade === '9' || grade === '30') {
  GRADEWORDS = FRESHMAN
} else {
  GRADEWORDS = nogradeyet
}

export const VALID_GUESSES = GRADEWORDS
